import React from "react";

const TagSelector = ({ allTags, selectedTags, toggleTag }) => {
  if (!allTags || allTags.length === 0) return null;

  return (
    <div className="tags-selector is-inline-block">
      <div className="tags">
        {allTags.map(tag => (
          <span
            key={tag}
            className={`tag is-small ${selectedTags.includes(tag) ? 'has-background-grey-light has-text-dark' : 'is-light'}`}
            onClick={() => toggleTag(tag)}
            style={{ 
              cursor: 'pointer', 
              marginRight: '0.3rem', 
              marginBottom: '0.3rem',
              fontWeight: selectedTags.includes(tag) ? '500' : 'normal'
            }}
          >
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
};

export default TagSelector;
